var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHrMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H87.5L100 12.5V100H0V0Z",
    fill: "#33CCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.925 20H47.5V25H57.5V40H67.5V35H62.5V27.925L75 38.65V75H42.5V80H80V36.35L60.925 20Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 35H27.5V62.5H32.5V35H40V20H20V35ZM25 25H35V30H25V25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66.475L30 71.475L25 66.475V40H20V68.525L30 78.525L40 68.525V40H35V66.475Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrMini);
export default __webpack_public_path__ + "static/media/hr_mini.31a93a68a2d3a3dc41c9b23b357ca16b.svg";
export { ForwardRef as ReactComponent };